/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {service as TagService} from '../../../Services/TagService';
import {usePrimeCache} from '../../../Hooks/ServiceHooks';

// Renders a file's tag set as a list of tag names. Used by the activity feed's
// delta display (ActivityFeedValueDeltaDisplay) to show the before/after tags on
// a file_tags_update event. Value is an array of {tagId} entries.
export const TagListFieldViewer = ({Value: tags}) => {
    usePrimeCache([TagService]);

    const assigned = Array.isArray(tags) ? tags : [];

    if (!assigned.length) {
        return <span className="sb-activity-feed-tag-list-empty">No tags</span>;
    }

    return (
        <ul className="sb-activity-feed-tag-list">
            {assigned.map((tag, index) => (
                <li key={index}>{TagService.CachedTitleById(tag.tagId) ?? `Tag ${tag.tagId}`}</li>
            ))}
        </ul>
    );
};
